
import Vue from "vue";
import InvoiceDetails from "@/components/InvoiceDetails.vue";
import { IInvoiceData } from "../types";
import InvoiceSearch from "@/components/InvoiceSearch.vue";

export default Vue.extend({
  name: "invoice-main",
  components: { InvoiceSearch, InvoiceDetails },
  data: function() {
    return {
      invoices: [] as IInvoiceData[]
    };
  },
  methods: {
    updateInvoice(invoices: IInvoiceData[]) {
      this.invoices = invoices;
    },
    saveInvoiceToStore() {
      //@ts-ignore
      this.$refs.invoiceDetails.saveToStore();
    }
  }
});
